import React from 'react';
import { Card } from '../../../components/CssFrameworkComponents';
import RenderingDeviceCard from './renderingDeviceCard';

const TITLE = 'Rendering devices';

const DESCRIPTIONS = [
  // eslint-disable-next-line max-len
  "You can optimize your website's rendering based on the crawling bot that requests your page. For example, Google's mobile rendering bot can receive a mobile-optimized version of your site, while the desktop bot will get a desktop rendering.",
  // eslint-disable-next-line max-len
  'With Mobile Optimized Rendering activated, we will start caching mobile pages when mobile crawlers request them. Alternatively, you can use our re-cache API with adaptive type set to “Mobile” to pre-cache mobile versions of your cached pages. You can also prompt your sitemaps to be crawled for mobile page caching directly in the Sitemaps section.',
  // eslint-disable-next-line max-len
  'Note: turning on both rendering devices will cause you to render each page for each device, effectively multiplying your number of renders.',
];

const DESKTOP_RESOLUTION_OPTIONS = [
  { text: `Default - (1440x718)`, width: 1440, height: 718 },
  { text: 'Full HD (1920x1080)', width: 1920, height: 1080 },
  { text: 'Full HD Lazy Loaded (1920x12000)', width: 1920, height: 12000 },
  { text: '4k (3840x2160)', width: 3840, height: 2160 },
  { text: '4k Lazy Loaded (3840x24000)', width: 3840, height: 24000 },
  { text: 'HD (1024x768)', width: 1024, height: 768 },
  { text: 'HD Lazy Loaded (1024x8140)', width: 1024, height: 8140 },
];

const MOBILE_RESOLUTION_OPTIONS = [
  { text: `Default - iPhone SE (375x667)`, width: 375, height: 667 },
  { text: 'iPhone SE Lazy Loaded (375x6700)', width: 375, height: 6700 },
  { text: 'iPhone 12 Pro (390x844)', width: 390, height: 844 },
  { text: 'iPhone 12 Pro Lazy Loaded (390x9000)', width: 390, height: 9000 },
  { text: 'iPad Air (820x1180)', width: 820, height: 1180 },
  { text: 'iPad Air Lazy Loaded (820x12000)', width: 820, height: 12000 },
];

const RenderingDevicesCard = () => {
  return (
    <Card title={TITLE}>
      <div className="col">
        <div className="row">
          {DESCRIPTIONS.map((description) => (
            <p key={description}>{description}</p>
          ))}
        </div>
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <RenderingDeviceCard
              device="desktop"
              title="Desktop Optimized Rendering"
              icon="fe-monitor"
              resolutionOptions={DESKTOP_RESOLUTION_OPTIONS}
            />
          </div>

          <div className="col-md-12 col-lg-6">
            <RenderingDeviceCard
              device="mobile"
              title="Mobile Optimized Rendering"
              icon="fe-smartphone"
              resolutionOptions={MOBILE_RESOLUTION_OPTIONS}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default RenderingDevicesCard;
